// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yDGBV","content":"styles_content__QYOyY","row":"styles_row__5zE13","footer":"styles_footer__1f12F","phraseLength":"styles_phraseLength__1b9N1"};